import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.css']
})
export class HistoricalDataComponent implements OnInit {

  years = [] as any
  selects: any = { year: (Number(new Date().getFullYear()) + 543).toString() };
  iframe_url: any;
  urlSafe!: SafeResourceUrl;
  maximized = false

  iframe_type = 'history_trialbalance'
  iframe_data: any;
  iframe_form = new FormGroup({
    year: new FormControl('', [Validators.required]),
    iframe: new FormControl('', [Validators.required]),
    edit: new FormControl('', [Validators.required]),
    type: new FormControl('')
  });

  constructor(
    public sanitizer: DomSanitizer,
    public services: ApiService
  ) { }

  async ngOnInit(): Promise<void> {
    document.getElementById('historicaldata')!.classList.add("active");
    document.getElementById('history')!.classList.add("show");
    document.getElementById('h_trialbalance')!.classList.add("active");

    await this.setIframe()
    this.selects.year = (Number(new Date().getFullYear()) + 543).toString()
  }

  ngOnDestroy() {
    document.getElementById('historicaldata')!.classList.remove("active");
    document.getElementById('history')!.classList.remove("show");
    document.getElementById('h_trialbalance')!.classList.remove("active");
  }

  onClickSearch(selects: any) {
    this.setIframe()
    // if (selects.type == "cashflow") {
    //   switch (selects.year) {
    //     case '2559': {
    //       this.iframe_url = "";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2560': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21157&authkey=%21ALHdyVamCplvsws&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2060'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2561': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21155&authkey=%21AFfNOHhJUAeH4u8&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2061'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2562': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21154&authkey=%21AFc4LjWhmKKTGX0&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2062'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2563': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21150&authkey=%21ACZUPSppnH1tiZU&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2063'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2564': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21147&authkey=%21AMNnOgi65ZcBAmc&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2064'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2565': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21148&authkey=%21ANdmZmQRJ1HZhtY&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2065'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2566': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21144&authkey=%21AAxkehgIc4JFfvQ&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2066'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2567': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21142&authkey=%21AP__iS433fudMs8&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2067'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2568': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21140&authkey=%21AMRwtPCcNAfmdBw&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2068'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2569': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21135&authkey=%21AOU93mFBMyb50sk&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2069'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2570': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21138&authkey=%21AMBnDOONNTDI3go&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2070'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2571': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21134&authkey=%21AIoktD3On889gwo&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2071'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2572': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21121&authkey=%21APYyqToB4tluOYg&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2072'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2573': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21118&authkey=%21ACbJeIwyQ0EBMeI&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2073'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     case '2574': {
    //       this.iframe_url = "https://onedrive.live.com/embed?resid=499041317759588D%21128&authkey=%21ACVE5l5lF_lge_g&em=2&wdAllowInteractivity=False&ActiveCell='CASHFLOW%20%E0%B8%9B%E0%B8%B5%2074'!B5&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True";
    //       this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    //       break;
    //     }
    //     default: {
    //       // console.log('selected not found');
    //       break;
    //     }
    //   }
    // }
  }

  onClickEdit() {
    if (this.iframe_data) {
      window.open(this.iframe_data.edit_url, "_blank");
    }

    // if (this.selects.type == "cashflow") {
    //   switch (this.selects.year) {
    //     case '2559': {
    //       window.open("", "_blank");
    //       break;
    //     }
    //     case '2560': {
    //       window.open("https://bit.ly/3vjDNQQ", "_blank");
    //       break;
    //     }
    //     case '2561': {
    //       window.open("https://bit.ly/3fcIiqY", "_blank");
    //       break;
    //     }
    //     case '2562': {
    //       window.open("https://bit.ly/3wr5lnG", "_blank");
    //       break;
    //     }
    //     case '2563': {
    //       window.open("https://bit.ly/2SprHqI", "_blank");
    //       break;
    //     }
    //     case '2564': {
    //       window.open("https://bit.ly/3hONOlm", "_blank");
    //       break;
    //     }
    //     case '2565': {
    //       window.open("https://bit.ly/3yy1qXT", "_blank");
    //       break;
    //     }
    //     case '2566': {
    //       window.open("https://bit.ly/3feyr3I", "_blank");
    //       break;
    //     }
    //     case '2567': {
    //       window.open("https://bit.ly/348xio6", "_blank");
    //       break;
    //     }
    //     case '2568': {
    //       window.open("https://bit.ly/3bP1LvJ", "_blank");
    //       break;
    //     }
    //     case '2569': {
    //       window.open("https://bit.ly/3ugh8na", "_blank");
    //       break;
    //     }
    //     case '2570': {
    //       window.open("https://bit.ly/3wt9dEz", "_blank");
    //       break;
    //     }
    //     case '2571': {
    //       window.open("https://bit.ly/3oGRnvk", "_blank");
    //       break;
    //     }
    //     case '2572': {
    //       window.open("https://bit.ly/3ufHZ31", "_blank");
    //       break;
    //     }
    //     case '2573': {
    //       window.open("https://bit.ly/3bR3MYf", "_blank");
    //       break;
    //     }
    //     case '2574': {
    //       window.open("https://bit.ly/3fISsOT", "_blank");
    //       break;
    //     }
    //     default: {
    //       break;
    //     }
    //   }
    // }
  }

  async setIframe() {
    let arr_iframe = [] as any
    await this.services.get('m_iframe_url').then((res: any) => {
      arr_iframe = res.filter((f: any) => {
        f.id = Number(f.id)
        if (f.type == this.iframe_type) {
          this.years.push((f.year))
          if (f.iframe) {
            f.iframe = JSON.parse(f.iframe)
            f.iframe_url = f.iframe.join("'");
          }
          if (f.edit) {
            f.edit = JSON.parse(f.edit)
            f.edit_url = f.edit.join("'");
          }
        }
        return f.type == this.iframe_type && f.year == this.selects.year
      })
    })
    this.years = [...new Set(this.years)];
    this.years.sort()
    if (arr_iframe.length > 0) {
      arr_iframe = arr_iframe.sort((a: any, b: any) => (a.id > b.id) ? -1 : ((b.id > a.id) ? 1 : 0))
      this.iframe_data = arr_iframe[0]
      this.iframe_url = this.iframe_data.iframe_url;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    }
  }
  addIframe() {
    this.iframe_form.patchValue({
      type: this.iframe_type,
      iframe: JSON.stringify(this.iframe_form.value.iframe.split("'")),
      edit: JSON.stringify(this.iframe_form.value.edit.split("'"))
    })

    this.services.create('m_iframe_url', this.iframe_form.value).then((res: any) => {
      if (res) {
        this.setIframe()
        this.iframe_form.reset()
        $('#updateURL_ht').modal('hide');
        Swal.fire({
          title: 'อัพเดต URL สำเร็จ',
          icon: 'success',
          confirmButtonText: `ตกลง`,
          showConfirmButton: false,
          timer: 1500
        })

      }
    })
  }

  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  maximizeorMinimize(table_name: any, btn_name: any) {
    var table = document.getElementById(table_name);
    var btn = document.getElementById(btn_name);
    if (!this.maximized) {
      table!.style.position = 'fixed';
      table!.style.zIndex = '99';
      table!.style.background = 'white';
      table!.style.width = "100vw";
      table!.style.height = "90vh";
      table!.style.top = "12%";
      table!.style.left = "0";
      table!.style.marginTop = "0px";
      btn!.setAttribute('src', "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///8AAADo6OgwMDB0dHTCwsI3NzdwcHAgICDU1NRhYWGWlpZLS0va2tqSkpLHx8e5ublZWVknJyfe3t5BQUGjo6NmZmYXFxf19fVTU1NcXFympqavr68YGBgODg62trZ7e3vm1eqLAAACtUlEQVR4nO3d7VLiQBBGYT5CICQIsqIssuj9X+UWtaXlTK2ka7rdd9Y6zwUMc0xiBn/YkwkAAAAAAAAAAMB/aNs3QzvXaoem335N3mI9rcd6Ed53uKijMpdDaF+3Ugf9xX4TF3injvlEHxVY0wOYeowJfFB33DBEBNZ7Ba8CrmKtz+Ab97PYqQtGeX+j7tUBo1pf4LN6/wZnV6F69xYrT+CLevcmnjPqkC922nUzrW53n29qXR54zJba/3D8tOJs8lNy+VKLdKHVMW6XLsfsi05XvFL2tq/jCl5lb+nyt356YHPc7uF+Jjt7LV6nTdbZhe3P75zsrPz8Pa/0Js1v0/JjTVo4C9yh1yzZ2bx4HQp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCK3tht4h367+S/vvC5TTesqrC5gsKGwoppJBCCimkkEIKgwu//7n0sGyiLW8NVuP7oRWFOhRaUahDoRWFOhRaUahDoRWFOhRaUahDoRWFOlGF6YRH73joSJtkZ+XzD9O58S+BO/RKBxU/FK+T/p33FLhDr3Qm8K2/Hd/WJ+tUNKYzvUkds2S36UL1zAN+Sje2LV8qXegbznTOxu5OK53Lfe8o3OWLVckzW31yGV9f7pcnMJudXKezq3CyV+9/VPmR7Y9u/CPE3IfJu/HPkCp/279bj3+K0KM/MD9/16V8bnyi3qsYcgWvan0WA57BN11+EqzBPvYr+UHdk3t6Du272p3UUR+sXWfRz237ZmjnWu3Q9I7vgwAAAAAAAAAAADq/AeDROLr9IlTcAAAAAElFTkSuQmCC");
      btn!.style.width = "30px";
      btn!.style.height = "30px";
      btn!.style.marginRight = "15px";
      btn!.title = "Minimize";
      this.maximized = true;
    } else {
      table!.style.position = 'relative';
      table!.style.zIndex = '5';
      table!.style.width = "100%";
      table!.style.height = "100vh";
      table!.style.top = "0%";
      table!.style.borderRadius = "15px";
      table!.style.marginTop = "80px";
      btn!.title = "Maximize";
      btn!.style.width = "15px";
      btn!.style.height = "15px";
      btn!.style.marginRight = "5px";
      btn!.style.marginTop = "5px";
      btn!.setAttribute('src', "https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png");
      this.maximized = false;
    }
  }
}
